/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespLocationsModule_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationItems_viewer">;
    readonly " $refType": "HpRespLocationsModule_viewer";
};
export type HpRespLocationsModule_viewer$data = HpRespLocationsModule_viewer;
export type HpRespLocationsModule_viewer$key = {
    readonly " $data"?: HpRespLocationsModule_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModule_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespLocationsModule_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpRespLocationItems_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '6f46ede06d7ce74f09b6e6e6987cd223';
export default node;
